<template>
    <el-header style="height: 80px;">

        <el-row class="tops-layout2">
            <el-col :span="12" class="pl10">
                <el-link class="el-dropdown-left"><i class="el-icon-s-fold"></i></el-link>
                <div class="el-dropdown-left">智联卡平台 / SIM卡管理 / SIM卡列表</div>
            </el-col>
            <el-col :span="12" class="pr10">

                <div class="el-dropdown-right">
                    <el-dropdown trigger="click" @command="handleCommand">
                        <el-link class="icon-downs dropbar">
                            <el-avatar size="small" class="user-icon-i" :src="userIcon"></el-avatar>
                        </el-link>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item icon="el-icon-user">个人中心</el-dropdown-item>
                            <el-dropdown-item icon="el-icon-suitcase">订阅</el-dropdown-item>
                            <el-dropdown-item icon="el-icon-right" command="logout">退出</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                
                <!-- <el-link class="el-dropdown-right"><i class="el-icon-full-screen"></i></el-link> -->
                <el-link class="el-dropdown-right"><i class="el-icon-bell"></i></el-link>
                <el-link class="el-dropdown-right"><i class="el-icon-search"></i></el-link>
                <el-link class="el-dropdown-right"><i class="el-icon-chat-dot-square"></i></el-link>
            </el-col>
        </el-row>

        <div class="el-scrollbar">
            <div class="el-scrollbar__wrap el-scrollbar__wrap--hidden-default">
                <div class="el-scrollbar__view">
                    <ul class="layout-navbars-tagsview-ul tags-style-five">

                        <li v-for="(item, index) in editableTabs" :class="['layout-navbars-tagsview-ul-li', item.activeState]" @click="tabClick(item)">
                            <i v-if="item.activeState == 'is-active'" class="iconfont icon-webicon318 layout-navbars-tagsview-ul-li-iconfont"></i>
                            <span>{{item.title}}</span>
                            <i class="el-icon-close nav-tab-close" @click="closeNavTab(item.name)"></i>
                        </li>

                    </ul>
                </div>
            </div>
        </div>

    </el-header>
</template>

<script>
import Api from '../api/index'

export default {
  name: 'header_nav_menu',
  data() {
    return {
        activeIndex2: "home",
        selectionMenuId: "/sims/manage",
        logoRaw: require("../assets/simiconlogo.png"),
        userIcon: require("../assets/tuzi.png"),
        userCenterIcon: require("../assets/user_purple.png"),
        modularFuns: [],

        editableTabsValue: 'a1',
        editableTabs: [
            {
                name: "a1",
                title: "SIM卡管理",
                content: "",
                path: "/sims/manage",
                activeState: "is-active",
            }
        ],
        tabIndex: 2
    }
  },
  methods: {
    goBack() {
        console.log('go back');
    },
    addTab(targetName) {
        let newTabName = ++this.tabIndex + '';
        this.editableTabs.forEach(item => {
            item.activeState = "";
        });
        this.editableTabs.push({
            title: 'New Tab',
            name: newTabName,
            content: 'New Tab content',
            activeState: "is-active"
        });
    },
    tabClick(item) {
        this.$router.push(item.path);
        for(var i=0; i<this.editableTabs.length; i++) {
            if(this.editableTabs[i].name === item.name) {
                this.editableTabs[i].activeState = "is-active";
            } else {
                this.editableTabs[i].activeState = "";
            }
        }
    },
    removeAllTabs() {
        let newTabs = [];
        let tabs = this.editableTabs;
        let activeName = this.editableTabsValue;
        tabs.forEach((tab, index) => {
            if(tab.name == activeName) {
                newTabs.push(tab);
            }
        });
        this.editableTabs = newTabs;
    },
    handleDpCommand(command) {
        switch(command) {
            case "a":
                this.removeAllTabs();
                break;
            case "b":
                var path = "/sys/setting";
                var obj = {
                    id: "11",
                    name: "个人设置",
                    path: path
                };
                this.addTabPane(obj);
                this.$router.push(path);
                break;
            case "c":
                this.logout();
            default: break;
        }
    },
    loadModularFuns: function() {
        Api.GetFuns({}).then((res) => {
            if(res && res.code === 200) {
                var menuNavList = [];
                for(var i=0; i<res.data.length; i++) {
                    menuNavList.push({
                        funId: res.data[i].funId,
                        funName: res.data[i].funName,
                        funPath: res.data[i].funPath
                    });
                }
                this.modularFuns = menuNavList;
            } else if(res.code === 401) {
                this.$router.push("../Login");
            }
        });

        var url = window.location.href;
        if(url.split('/#')[1])
            this.selectionMenuId = url.split('/#')[1];
    },
    handleMenuItem: function(path) {
        //alert(path);
        this.$router.push(path);
        this.selectionMenuId = path; // this.$route.path;
    },
    handleSelect: function() {

    },
    handleNodePath: function(path) {
        //this.selectionMenuId = path;
    },
    closeNavTab: function(name) {
        if(this.editableTabs.length === 1) {
            this.$message.error('最少保留一个Tab菜单');
            return;
        }
        let rmCurrent = false;
        let list = [];
        for(var i=0; i<this.editableTabs.length; i++) {
            if(this.editableTabs[i].name === name) {
                if(this.editableTabs[i].activeState === "is-active") {
                    // 关闭当前页，跳转上一页
                    rmCurrent = true;
                    this.editableTabs[i].activeState = "";
                }
            } else {
                list.push(this.editableTabs[i]);
            }
        }
        this.editableTabs = list;
        if(rmCurrent) {
            let last = this.editableTabs.length - 1;
            this.$router.push(this.editableTabs[last].path);
            this.editableTabs[last].activeState = "is-active";
        }
    },
    addTabPane(obj) {
        console.log(obj)
        this.editableTabs.forEach(item => {
            item.activeState = "";
        });
        let existsPath = false;
        let tabs = this.editableTabs;
        for(var i=0; i<tabs.length; i++) {
            if(tabs[i].path === obj.path) {
                existsPath = true;
                this.editableTabs[i].activeState = "is-active";
                break;
            }
        }

        if(!existsPath) {
            this.editableTabs.push({
                title: obj.name,
                name: obj.id,
                content: '',
                path: obj.path,
                activeState: "is-active"
            });
        } else {
            console.log("菜单已存在！");
        }

        this.editableTabsValue = obj.id;
    },
    handleCommand(command) {
        //this.$message('click on item ' + command);
        if(command == "logout") {
            this.logout();
        } else if(command == "user") {
            //user center
        }
    },
    logout: function() {
        this.$confirm('确定要退出平台吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            Api.Logout({}).then((res) => {
                console.log(res);
                this.$router.push("../Login");
            });
        }).catch(() => {
            console.log('已取消删除');
        });
    }
  },
  mounted() {

    // 加载主导航菜单
    //this.loadModularFuns();
  }
}
</script>

<style>
style attribute {
    --next-bg-menuBar: #FFFFFF;
    --next-bg-menuBar-light-1: #ffffff;
    --next-bg-menuBarActiveColor: #f0edfd;
    --next-bg-menuBarColor: #606266;
    --next-bg-topBar: #FFFFFF;
    --next-bg-topBarColor: #606266;
    --next-bg-columnsMenuBar: #333333;
    --next-bg-columnsMenuBarColor: #eaeaea;
    --next-color-columnsMenuBarActiveColor: #ffffff;
    --el-color-primary: #6954f0;
    --el-color-primary-light-1: #7865f1;
    --el-color-primary-light-2: #8776f3;
    --el-color-primary-light-3: #9687f4;
    --el-color-primary-light-4: #a598f6;
    --el-color-primary-light-5: #b4a9f7;
    --el-color-primary-light-6: #c3baf9;
    --el-color-primary-light-7: #d2cbfa;
    --el-color-primary-light-8: #e1dcfc;
    --el-color-primary-light-9: #f0edfd;
    --el-color-primary-dark-2: #5e4bd8;
    --my-captcha-width: 378px;
    --el-menu-bg-color: #FFFFFF;
}

.dom-person {
    float: right;
    margin: 10px 10px 0 0;
    height: 36px;
}

/* 外层容器，宽度100% */
.outer-container {
    width: 100%;
    background-color: #ffffff;
    padding: 0;
    box-sizing: border-box;
}

/* 清除浮动 */
.clearfix::after {
    content: "";
    display: table;
    clear: both;
}

/* 左侧固定宽度 */
.left-side {
    width: 200px;
    float: left;
    padding: 0;
    box-sizing: border-box;
    border-bottom: #cccccc 1px solid;
}

.left-side2-container {
    height: 50px;
    padding-top: 10px;
    text-align: center;
}

/* 右侧自适应宽度 */
.right-side {
    margin-left: 210px; /* 等于左侧宽度 */
    background-color: #ffffff;
    color: #333333;
    padding: 0;
    box-sizing: border-box;
}

.right-side-container {
    height: 50px;
    padding-top: 14px;
}

.user-icon-i {
    margin-top: 12px;
}

.tops-layout2 {
  width: 100%;
  height: 40px;
  align-items: center;
}
.tops-layout2::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 200px;  /* 从 padding-left 的位置开始 */
  width: calc(100% - 200px); /* 剩余宽度 */
  height: 1px;
  background-color: #cccccc; /* 你想要的边框颜色 */
}

.tops-layout2>.el-col {
  height: 40px;
  align-items: center;
}
.el-dropdown-left, .el-dropdown-right {
    display: inline-flex;
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    position: relative;
    vertical-align: top;
}
.el-dropdown-left {
  float: left;
  margin-left: 10px;
}
.el-dropdown-right {
  float: right;
  margin-right: 10px;
}
.icon-downs {
    margin-right: 3px;
}
.dropbar {
    height: 40px;
    line-height: 40px;
}
.pl10 {
    padding-left: 200px !important;
}
.pr10 {
    padding-right: 10px !important;
}

.el-scrollbar {
    --el-scrollbar-opacity: .3;
    --el-scrollbar-bg-color: #909399;
    --el-scrollbar-hover-opacity: .5;
    --el-scrollbar-hover-bg-color: #909399;
    height: 38px;
    line-height: 38px;
    overflow: hidden;
    position: relative;
    background-color: #ffffff;
}
.el-scrollbar__wrap {
    max-height: 100%;
    height: 100%;
    overflow: auto;
}
.el-scrollbar__wrap--hidden-default {
    scrollbar-width: none;
}
.layout-container-view .el-scrollbar__view {
    height: 38px;
    line-height: 38px;
}

.layout-navbars-tagsview {
    background-color: var(--el-bg-color-overlay);
    border-bottom: 1px solid var(--next-border-color-light);
    position: relative;
    z-index: 4
}

.layout-navbars-tagsview .el-scrollbar__wrap {
    overflow-x: auto!important
}

.layout-navbars-tagsview-ul {
    list-style: none;
    margin: 0;
    height: 38px;
    display: flex;
    align-items: center;
    color: var(--el-text-color-regular);
    font-size: 12px;
    white-space: nowrap;
    padding-left: 210px;
}

.layout-navbars-tagsview-ul-li {
    height: 26px;
    line-height: 26px;
    display: flex;
    align-items: center;
    border: 1px solid var(--el-border-color-lighter);
    padding: 0 15px;
    margin-right: 5px;
    border-radius: 2px;
    position: relative;
    z-index: 0;
    cursor: pointer;
    justify-content: space-between
}

.layout-navbars-tagsview-ul-li:hover {
    background-color: var(--el-color-primary-light-9);
    color: var(--el-color-primary);
    border-color: var(--el-color-primary-light-5)
}

.layout-navbars-tagsview-ul-li-iconfont {
    position: relative;
    left: -5px;
    font-size: 12px
}

.layout-navbars-tagsview-ul-li-icon {
    border-radius: 100%;
    position: relative;
    height: 14px;
    width: 14px;
    text-align: center;
    line-height: 14px;
    right: -5px
}

.layout-navbars-tagsview-ul-li-icon:hover {
    color: #ffffff;
    background-color: var(--el-color-primary-light-3)
}

.layout-navbars-tagsview-ul-li .layout-icon-active {
    display: block
}

.layout-navbars-tagsview-ul-li .layout-icon-three {
    display: none
}

.layout-navbars-tagsview-ul .is-active {
    color: #ffffff;
    background: #a28efd;
    border-color: #a28efd;
    transition: border-color 3s ease
}

.layout-navbars-tagsview .tags-style-four .layout-navbars-tagsview-ul-li {
    margin-right: 0!important;
    border: none!important;
    position: relative;
    border-radius: 3px!important
}

.layout-navbars-tagsview .tags-style-four .layout-navbars-tagsview-ul-li .layout-icon-active {
    display: none
}

.layout-navbars-tagsview .tags-style-four .layout-navbars-tagsview-ul-li .layout-icon-three {
    display: block
}

.layout-navbars-tagsview .tags-style-four .layout-navbars-tagsview-ul-li:hover {
    background: none!important
}

.layout-navbars-tagsview .tags-style-four .is-active {
    background: none!important;
    color: var(--el-color-primary)!important
}

.layout-navbars-tagsview .tags-style-five {
    align-items: flex-end
}

.layout-navbars-tagsview .tags-style-five .tags-style-five-svg,.layout-navbars-tagsview .tags-style-five .is-active,.layout-navbars-tagsview .tags-style-five .layout-navbars-tagsview-ul-li:hover {
    -webkit-mask-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzAiIGhlaWdodD0iNzAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZmlsbD0ibm9uZSI+CgogPGc+CiAgPHRpdGxlPkxheWVyIDE8L3RpdGxlPgogIDxwYXRoIHRyYW5zZm9ybT0icm90YXRlKC0wLjEzMzUwNiA1MC4xMTkyIDUwKSIgaWQ9InN2Z18xIiBkPSJtMTAwLjExOTE5LDEwMGMtNTUuMjI4LDAgLTEwMCwtNDQuNzcyIC0xMDAsLTEwMGwwLDEwMGwxMDAsMHoiIG9wYWNpdHk9InVuZGVmaW5lZCIgc3Ryb2tlPSJudWxsIiBmaWxsPSIjRjhFQUU3Ii8+CiAgPHBhdGggZD0ibS0wLjYzNzY2LDcuMzEyMjhjMC4xMTkxOSwwIDAuMjE3MzcsMC4wNTc5NiAwLjQ3Njc2LDAuMTE5MTljMC4yMzIsMC4wNTQ3NyAwLjI3MzI5LDAuMDM0OTEgMC4zNTc1NywwLjExOTE5YzAuMDg0MjgsMC4wODQyOCAwLjM1NzU3LDAgMC40NzY3NiwwbDAuMTE5MTksMGwwLjIzODM4LDAiIGlkPSJzdmdfMiIgc3Ryb2tlPSJudWxsIiBmaWxsPSJub25lIi8+CiAgPHBhdGggZD0ibTI4LjkyMTM0LDY5LjA1MjQ0YzAsMC4xMTkxOSAwLDAuMjM4MzggMCwwLjM1NzU3bDAsMC4xMTkxOWwwLDAuMTE5MTkiIGlkPSJzdmdfMyIgc3Ryb2tlPSJudWxsIiBmaWxsPSJub25lIi8+CiAgPHJlY3QgaWQ9InN2Z180IiBoZWlnaHQ9IjAiIHdpZHRoPSIxLjMxMTA4IiB5PSI2LjgzNTUyIiB4PSItMC4wNDE3MSIgc3Ryb2tlPSJudWxsIiBmaWxsPSJub25lIi8+CiAgPHJlY3QgaWQ9InN2Z181IiBoZWlnaHQ9IjEuNzg3ODQiIHdpZHRoPSIwLjExOTE5IiB5PSI2OC40NTY1IiB4PSIyOC45MjEzNCIgc3Ryb2tlPSJudWxsIiBmaWxsPSJub25lIi8+CiAgPHJlY3QgaWQ9InN2Z182IiBoZWlnaHQ9IjQuODg2NzciIHdpZHRoPSIxOS4wNzAzMiIgeT0iNTEuMjkzMjEiIHg9IjM2LjY2ODY2IiBzdHJva2U9Im51bGwiIGZpbGw9Im5vbmUiLz4KIDwvZz4KPC9zdmc+),url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzAiIGhlaWdodD0iNzAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZmlsbD0ibm9uZSI+CiA8Zz4KICA8dGl0bGU+TGF5ZXIgMTwvdGl0bGU+CiAgPHBhdGggdHJhbnNmb3JtPSJyb3RhdGUoLTg5Ljc2MjQgNy4zMzAxNCA1NS4xMjUyKSIgc3Ryb2tlPSJudWxsIiBpZD0ic3ZnXzEiIGZpbGw9IiNGOEVBRTciIGQ9Im02Mi41NzQ0OSwxMTcuNTIwODZjLTU1LjIyOCwwIC0xMDAsLTQ0Ljc3MiAtMTAwLC0xMDBsMCwxMDBsMTAwLDB6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgogIDxwYXRoIGQ9Im0tMC42Mzc2Niw3LjMxMjI4YzAuMTE5MTksMCAwLjIxNzM3LDAuMDU3OTYgMC40NzY3NiwwLjExOTE5YzAuMjMyLDAuMDU0NzcgMC4yNzMyOSwwLjAzNDkxIDAuMzU3NTcsMC4xMTkxOWMwLjA4NDI4LDAuMDg0MjggMC4zNTc1NywwIDAuNDc2NzYsMGwwLjExOTE5LDBsMC4yMzgzOCwwIiBpZD0ic3ZnXzIiIHN0cm9rZT0ibnVsbCIgZmlsbD0ibm9uZSIvPgogIDxwYXRoIGQ9Im0yOC45MjEzNCw2OS4wNTI0NGMwLDAuMTE5MTkgMCwwLjIzODM4IDAsMC4zNTc1N2wwLDAuMTE5MTlsMCwwLjExOTE5IiBpZD0ic3ZnXzMiIHN0cm9rZT0ibnVsbCIgZmlsbD0ibm9uZSIvPgogIDxyZWN0IGlkPSJzdmdfNCIgaGVpZ2h0PSIwIiB3aWR0aD0iMS4zMTEwOCIgeT0iNi44MzU1MiIgeD0iLTAuMDQxNzEiIHN0cm9rZT0ibnVsbCIgZmlsbD0ibm9uZSIvPgogIDxyZWN0IGlkPSJzdmdfNSIgaGVpZ2h0PSIxLjc4Nzg0IiB3aWR0aD0iMC4xMTkxOSIgeT0iNjguNDU2NSIgeD0iMjguOTIxMzQiIHN0cm9rZT0ibnVsbCIgZmlsbD0ibm9uZSIvPgogIDxyZWN0IGlkPSJzdmdfNiIgaGVpZ2h0PSI0Ljg4Njc3IiB3aWR0aD0iMTkuMDcwMzIiIHk9IjUxLjI5MzIxIiB4PSIzNi42Njg2NiIgc3Ryb2tlPSJudWxsIiBmaWxsPSJub25lIi8+CiA8L2c+Cjwvc3ZnPg==),url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'><rect rx='8' width='100%' height='100%' fill='%23F8EAE7'/></svg>");
    -webkit-mask-size: 18px 30px,20px 30px,calc(100% - 30px) calc(100% + 17px);
    -webkit-mask-position: right bottom,left bottom,center top;
    -webkit-mask-repeat: no-repeat
}

.layout-navbars-tagsview .tags-style-five .layout-navbars-tagsview-ul-li {
    padding: 0 5px;
    border-width: 15px 27px 15px;
    border-style: solid;
    border-color: transparent;
    margin: 0 -15px
}

.layout-navbars-tagsview .tags-style-five .layout-navbars-tagsview-ul-li .layout-icon-active,.layout-navbars-tagsview .tags-style-five .layout-navbars-tagsview-ul-li .layout-navbars-tagsview-ul-li-iconfont,.layout-navbars-tagsview .tags-style-five .layout-navbars-tagsview-ul-li .layout-navbars-tagsview-ul-li-refresh {
    display: none
}

.layout-navbars-tagsview .tags-style-five .layout-navbars-tagsview-ul-li .layout-icon-three {
    display: block
}

.layout-navbars-tagsview .tags-style-five .layout-navbars-tagsview-ul-li:hover {
    background: var(--el-color-primary-light-9);
    color: unset
}

.layout-navbars-tagsview .tags-style-five .is-active {
    background: #f0edfd !important;
    color: #6954f0 !important;
    z-index: 1;
}

.layout-navbars-tagsview-shadow {
    box-shadow: #0015290a 0 1px 4px
}

.nav-tab-close {
    margin-left: 5px;
}
</style>